import { createContext } from 'react';

export interface CoinBalanceContextType {
  balance: number | null;
  isLoading: boolean;
  refreshBalance: () => void;
}

export const CoinBalanceContext = createContext<CoinBalanceContextType | null>(null);
